var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.215698,
    width: 20.4947,
    height: 18,
    fill: "url(#pattern0)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_104_5010",
    transform: "matrix(0.0416667 0 0 0.0474415 0 -0.0692983)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_104_5010",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAArwAAAK8BK7AVuQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAG/SURBVEiJrdW9axRRFAXw391sMKISZFFTCyqiFlYWppZgYWEqC20U/wTBytJgaydok8IyjYWdBksrCzUWfgsRgpgUuhaRZzFvv8bZ3dHshcs9c96ZOW/efW9GSkk5cRcPEFXjFfpbWMG+v8YqxAeRch6tafAz68+Vx5oRsYgbmFXEFb1oRcSa0XENjYwbEfECu7CFO7DeN+OE+SF4WC7gVwVOWG9gbsTs0pjZwxS2M94ujc01K244i9vYi5M1DC4olvgU2orl6UZUzPI3Hile9SKma5g8wwecR2ucwUSjs0QPcW/Cz76OSx2DTymlp5N8ekQs0Nu//3LjYkSs5byfuSd93Ol+fdUuGhcHcCzjr7kex6GMZ/vF/2PwQ3FK4Xuu3zCTcXtHBimlZSyXuBPD9AM9iIjLEbGZcyVzL/u4M3U0o95gj94a7s+11cftrqkZarCBNxm/zfU1NjPeqqkZiISl/F0PRbNm0MzcdIerq8ncElL5HFxV7II2HmfufYeLiPmamm6UDZoVuMzV0VRf4CNWM36e66reIdpQNHGcZiC6PZhkyj0IfM4m78rOO4zDiCm8whHFH6w5wfyCm38AK6s1E8tYD3IAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a4a5f9dcf62fe7791998a5c5796733bd.svg";
export { ForwardRef as ReactComponent };